'use client'

import { useState } from 'react'
import { ChevronDown } from 'lucide-react'
import { cn } from '@/utilities/ui'
import type { LexicalFAQBlock } from '@/payload-types'

export function LexicalFAQClient({ title, items }: LexicalFAQBlock) {
  const [open, setOpen] = useState<number | null>(0)

  if (!items?.length) return null

  return (
    <div className="my-14 md:my-16">
      {title && (
        <h3 className="text-xl md:text-2xl font-bold uppercase font-metropolis text-text-primary mb-4">
          {title}
        </h3>
      )}
      <ul className="flex flex-col divide-y divide-border-brand border-y border-border-brand">
        {items.map((item, idx) => {
          const isOpen = open === idx
          return (
            <li key={idx}>
              <button
                type="button"
                onClick={() => setOpen(isOpen ? null : idx)}
                aria-expanded={isOpen}
                className="w-full flex items-center justify-between gap-4 py-4 text-left text-text-primary hover:text-text-brand transition-colors"
              >
                <span className="font-montserrat font-medium text-base md:text-lg">
                  {item.question}
                </span>
                <ChevronDown
                  className={cn(
                    'shrink-0 size-5 transition-transform duration-300',
                    isOpen && 'rotate-180',
                  )}
                />
              </button>
              <div
                className={cn(
                  'overflow-hidden transition-[grid-template-rows] duration-300 grid',
                  isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]',
                )}
              >
                <div className="overflow-hidden">
                  <p className="pb-4 text-text-secondary body-base leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              </div>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
